<!-- eslint-disable vue/no-v-html -->
<template>
  <FormulateForm
    id="contact"
    v-model="formData"
    method="post"
    @submit="submitHandler"
  >
    <FormulateInput
      v-model="selectedCountry"
      name="country"
      :options="countryOptions"
      type="select"
      :placeholder="i18n.form.labels.country"
      :label="i18n.form.labels.country"
    />

    <FormulateInput
      v-if="departmentOptions && departmentOptions.length > 0"
      v-model="selectedDepartment"
      name="department"
      :options="departmentOptions"
      type="select"
      :placeholder="i18n.form.labels.department"
      :label="i18n.form.labels.department"
      validation="required"
      :validation-messages="i18n.form.validations.department"
    />

    <FormulateInput
      name="name"
      :label="i18n.form.labels.name"
      validation="bail|required:trim|nohtml"
      :validation-messages="i18n.form.validations.name"
    />

    <FormulateInput
      name="email"
      type="email"
      :label="i18n.form.labels.email"
      validation="bail|required:trim|email"
      :validation-messages="i18n.form.validations.email"
    />

    <FormulateInput
      name="bonusCode"
      type="text"
      label="bonus code"
      validation="nohtml"
      class="custom-form-element"
      aria-hidden="true"
    />
    <FormulateInput
      name="website"
      type="text"
      label="website"
      validation="nohtml"
      class="custom-form-element"
      aria-hidden="true"
    />

    <FormulateInput
      name="remark"
      type="textarea"
      :label="i18n.form.labels.remark"
      validation="bail|required:trim|nohtml"
      :validation-messages="i18n.form.validations.remark"
    />

    <FormulateInput
      type="hidden"
      name="ufprt"
    />

    <!-- Umbraco / infra -->
    <FormulateInput
      type="hidden"
      name="formToken"
      :value="formToken"
    />    

    <FormulateInput
      type="hidden"
      name="__RequestVerificationToken"
    />

    <FormulateInput
      type="hidden"
      name="label"
      :value="label"
    />

    <FormulateInput
      type="hidden"
      name="sublabel"
    />

    <FormulateInput
      type="hidden"
      name="locale"
      :value="locale"
    />

    <!-- agree box -->
    <FormulateInput
      name="agree"
      type="checkbox"
      validation="required"
      :validation-messages="i18n.form.validations.agree"
    >
      <template #label="{ id }">
        <label
          :for="id"
          v-html="i18n.form.labels.agree"
        />
      </template>
    </FormulateInput>

    <fields-control-buttons
      :is-loading="isLoading"
      :i18n="i18n"
      @previous="previousHandler"
    />
  </FormulateForm>
</template>

<script>
import FieldsControlButtons from '@/components/forms/fields/FieldsControlButtons.vue';
import UmbracoFormMixin from '@/mixins/UmbracoForm';

export default {
  name: 'ContactFormPartougroup',
  components: {
    FieldsControlButtons,
  },
  mixins: [UmbracoFormMixin],
  props: {
    uForm: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Partou',
    },
    i18n: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    formToken: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      callbackIsChecked: null,
      isLoading: false,
      isAboutFieldPreselected: false,
      selectedCountry: null,
      selectedDepartment: null,
    };
  },
  computed: {
    countryOptions() {
      return this.options.map((country) => ({
        label: country.Label,
        value: country.Label,
      }));
    },
    departmentOptions() {
      if (!this.selectedCountry) return [];

      const selectedCountryData = this.options.find(
        (country) => country.Label === this.selectedCountry,
      );
      return (
        selectedCountryData?.Departments.map((dept) => ({
          label: dept.Label,
          value: dept.Value,
        })) || []
      );
    },
  },
  mounted() {
    const urlPath = window.location.pathname;
    const urlSegments = urlPath.split('/').filter(Boolean);
    const urlCountryCode = urlSegments[0]?.toLowerCase();

    if (urlCountryCode === 'contact' || !urlCountryCode) {
      const defaultCountry = this.options.find(
        country => country.CountryCode === 'NL'
      );

      if (defaultCountry) {
        this.selectedCountry = defaultCountry.Label;
      }
    } else {
      const matchingCountry = this.options.find(
        country => country.CountryCode.toLowerCase() === urlCountryCode
      );

      if (matchingCountry) {
        this.selectedCountry = matchingCountry.Label;
      }
    }
  },
  methods: {
    async submitHandler() {
      this.isLoading = true;
      this.$el.submit();
    },
    previousHandler() {
      window.history.go(-1);
    },
  },
};
</script>
